// ----------------------------------------------------------------------

export const phoneNumber = [
  '365-374-4961',
  '904-966-2836',
];
